var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPlus = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 30,
  height: 30,
  viewBox: "10 10 10 10"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M19.5 14h-3.501v-3.501A.497.497 0 0 0 15.5 10h-1a.5.5 0 0 0-.5.5v3.501h-3.5c-.277 0-.5.223-.5.5v.999a.5.5 0 0 0 .5.5h3.501v3.501c0 .276.223.499.5.499h.999a.5.5 0 0 0 .5-.499v-3.502h3.501A.497.497 0 0 0 20 15.5v-1a.5.5 0 0 0-.5-.5"
})));
export default SvgPlus;